var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "toggle-wrapper" }, [
    _vm._v(" " + _vm._s(_vm.leftTxt) + " "),
    _c("label", { staticClass: "switch" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.toggleValue,
            expression: "toggleValue",
          },
        ],
        attrs: { type: "checkbox", disabled: _vm.disable },
        domProps: {
          checked: Array.isArray(_vm.toggleValue)
            ? _vm._i(_vm.toggleValue, null) > -1
            : _vm.toggleValue,
        },
        on: {
          click: function ($event) {
            return _vm.$emit("toggle", _vm.toggleValue)
          },
          change: function ($event) {
            var $$a = _vm.toggleValue,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_vm.toggleValue = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_vm.toggleValue = $$a
                    .slice(0, $$i)
                    .concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.toggleValue = $$c
            }
          },
        },
      }),
      _c("span", {
        staticClass: "slider round",
        class: { disabled: _vm.disable },
      }),
    ]),
    _vm._v(" " + _vm._s(_vm.rightTxt) + " "),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }